import React from "react";
import "./styles.css";

export const Pill = ({ children, inverted }) => {
  return (
    <div className={`pill ${inverted ? "pill-inverted" : ""}`}>{children}</div>
  );
};
